export function getdata(){
	var obj = {
			headData:[
				{
					title:"操作",
					prop:"cz",
					width:"",
					width:"150px",
					custom:true,
					fixed:'left',
				},
				{
					title:"",
					prop:"hj",
					width:"200px",
					custom:true,
					fixed:'left',
				},
				{
					title:"扣缴人纳税人识别号",
					prop:"zzs_7_x_1",align:'right',
					width:"200px",
					custom:true,
				},
				{
					title:"扣缴人名称",
					prop:"zzs_7_x_2",align:'right',
					width:"200px",
					custom:true,
				},
				{
					title:"征收机关名称",
					prop:"zzs_7_x_3",align:'right',
					width:"200px",
					custom:true,
				},
				{
					title:"代扣代缴项目",
					prop:"zzs_7_x_4",align:'right',
					width:"200px",
					custom:true,
				},
				{
					title:"代扣代缴凭证编号",
					prop:"zzs_7_x_5",align:'right',
					width:"200px",
					custom:true,
				},
				{
					title:"税额",
					prop:"zzs_7_x_6",align:'right',
					width:"200px",
					custom:true,
				},
			
			],
			tableData:[
			
			]
			
		
	}
	return obj
}
